import { Injectable } from '@angular/core';
import { ClientCustomFieldsComponent } from './custom-fields.component';

@Injectable({
	providedIn: 'root'
})
export class CustomFieldsSaveService {

	static component: ClientCustomFieldsComponent;

	constructor() { }

	public async savedSuccessfully(): Promise<void> {
		return await CustomFieldsSaveService.component.savedOnNavigationAway();
	}
}
